<template>
  <div class="animated fadeIn">
    <b-breadcrumb><strong>Quotation</strong></b-breadcrumb>
    <b-row style="margin-top:10px;">
      <b-col sm="12">
      <b-card header-tag="header">
          
      <div class="box col-md-12">
        <div class="container">
            <div id="app">
                <main role="main" class="mt-4">                    
                    <form @submit.prevent="saveInvoice">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table col-md-12" style="width: 100%">
                                        <thead>
                                            <tr >
                                                <th scope="col"></th>
                                                <th scope="col" class="heading_data">Quantity</th>
                                                <th scope="col" class="heading_data">Weight/Construction</th>
                                                <th scope="col text-right" class="heading_data">Price</th>
                                                <th scope="col text-right" class="heading_data">Consumption</th>
                                                <th scope="col text-right" class="heading_data">Cost / pc</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            <tr v-for="(invoice_product, k) in invoice_products" :key="k">
                                                <td scope="row" class="trashIconContainer">
                                                    <i class="fa fa-trash" @click="deleteRow(k, invoice_product)" style="font-size: 20px;color: red;"></i>
                                                </td>
                                                <td>
                                                    <input class="form-control" type="text" v-model="invoice_product.quality" />
                                                </td>
                                                <td>
                                                    <input class="form-control" type="text" v-model="invoice_product.weight" />
                                                </td>
                                                <td>
                                                    <input class="form-control text-right" type="number" min="0" step=".01" v-model="invoice_product.price" @change="calculateLineTotal(invoice_product)"
                                                    />
                                                </td>
                                                <td>
                                                    <input class="form-control text-right" type="number" min="0" step=".01" v-model="invoice_product.consumption" @change="calculateLineTotal(invoice_product)"
                                                    />
                                                </td>
                                                <td>
                                                    <input class="form-control text-right" readonly type="number" min="0" step=".01" v-model="invoice_product.cost" />
                                                </td>
                                            </tr>
                                            <tr v-show="invoice_products.length === 0">
                                                <td colspan="6">
                                                    <p class="text-center alert-danger p-2">
                                                        No products added/available.
                                                    </p>
                                                </td>
                                            </tr>

                                        </tbody>
                                        <tfoot>
                                          <div class="clearfix"></div>
                                            <div class="col-md-12 mb-2">
                                                <button type='button' class="btn-primary active" @click="addNewRow" style="width: 60px;">
                                                    <i class="fa fa-plus-circle">
                                                    Add</i>
                                                </button>
                                            </div>
                                            <tr class="col-md-12">
                                                <td colspan="5" class=" text-right" id="subdata">Sub Total : </td>
                                                <td class="text-right">
                                                  <input readonly class="form-control text-right" type="number" min="0" step=".01" v-model="total_cost" @change="calculateFinalTotal()" />
                                                </td>
                                            </tr>
                                            <tr class="col-md-12" bgcolor="#F8F8F8">
                                                <td  class="text-right" id="subdata" >Print Cost : </td>
                                                <td class="text-right">
                                                    <input class="form-control text-right"  type="number" min="0" step=".01" v-model="print_cost" @change="calculateFinalTotal()" 
                                                  />
                                                </td>
                                            
                                                <td  class="text-right" id="subdata">Embroidery : </td>
                                                <td class="text-right">
                                                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="embroidery" @change="calculateFinalTotal()"/>
                                                </td>
                                            
                                                <td  class="text-right" id="subdata">Misc. : </td>
                                                <td class="text-right">
                                                <input class="form-control text-right" type="number" min="0" step=".01" v-model="misc" @change="calculateFinalTotal()"/>
                                              </td>
                                            
                                                
                                            </tr>
                                            <tr bgcolor="#F8F8F8">
                                                <td  class="text-right" id="subdata">CM : </td>
                                                <td class="text-right">
                                                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="cm" @change="calculateFinalTotal()"/>
                                                </td>
                                                <td  class="text-right" id="subdata">Trims : </td>
                                                <td class="text-right">
                                                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="trims" @change="calculateFinalTotal()"/>
                                                </td>
                                                <td  class="text-right" id="subdata">Packaging Trims : </td>
                                                <td class="text-right">
                                                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="packaging_trims" @change="calculateFinalTotal()"/>
                                                </td>
                                           </tr>
                                            <tr bgcolor="#F8F8F8">
                                                
                                            
                                                <td  class="text-right" id="subdata">Packaging : </td>
                                                <td class="text-right">
                                                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="packaging" @change="calculateFinalTotal()"/>
                                                </td>
                                            
                                                <td  class="text-right" id="subdata">Transportation : </td>
                                                <td class="text-right">
                                                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="transportation" @change="calculateFinalTotal()"/>
                                                </td>
                                                <td></td><td></td>
                                            </tr>
                                            <tr bgcolor="#F8F8F8">
                                                <td  class="text-right" id="subdata">(Optional)Licensee Margin : </td>
                                                <td class="text-right">
                                                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="licensee_margin" @change="calculateFinalTotal()"/>
                                                </td>
                                                <td id="combocell" class="text-right">
                                                  <input readonly class="form-control text-right" type="number" min="0" step=".01" v-model="percent_cost2"/>
                                                </td>
                                            
                                                <td class="text-right" id="subdata">Margin : </td>
                                                <td class="text-left" id="combocell" >
                                                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="margin" @change="calculateFinalTotal()"/></td><td id="combocell" class="text-right">
                                                  <input readonly class="form-control text-right" type="number" min="0" step=".01" v-model="percent_cost2"/>
                                                </td>
                                            </tr>
                                            <tr>

                                                <td colspan="3" class="text-right" id="subdata">Remark : </td>
                                                <td class="text-right">
                                                  <textarea class="form-control text-left" rows="2" cols="24" v-modal="remark"/>
                                                </td>
                                                <td   class="text-right" id="subdata">Total : </td>
                                                <td class="text-right">
                                                  <input class="form-control text-right" readonly  type="number" min="0" step=".01"  v-model="total_final_cost" id="final"/>
                                                </td>
                                           
                                                
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            
                            <div class="col-md-12 mb-4 text-center">
                                <button type='button' class="btn btn-success submit_btn invoice-save-bottom" @click="saveInvoice" style="float: right;">
                                    <i class="fa fa-save"></i>
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                    <!-- Invoice -->
                </main>
            </div>
        </div>

      </div>
    
    </b-card>
    </b-col>
    </b-row>
    </div>
</template>


<script>
import CONSTANTS from '@/utils/constants';
import auth from '@/utils/auth';
import Vue from 'vue';



const axios = require('axios')

  export default {
    data() {
      return {
        invoice_subtotal: 0,
        invoice_total: 0,
        invoice_tax: 5,
        invoice_products: [{
            product_no: '',
            product_name: '',
            product_price: '',
            product_qty: '',
            line_total: 0
        }],
        total_cost: 0,
        final_cost: 0,
        print_cost: 0,
        embroidery: 0,
        misc: 0,
        cm: 0,
        trims: 0,
        packaging_trims: 0,
        packaging: 0,
        transportation: 0,
        licensee_margin: 0,
        margin: 0,
        remark: '',
        percent_cost1:0, 
        percent_cost2:0, 
        total_final_cost: 0,
      }

    },
     created: function () {
        
    },
     methods: {
       saveInvoice() {
            console.log(JSON.stringify(this.invoice_products));
        },
        // calculateTotal() {
        //     var subtotal, total;
        //     subtotal = this.invoice_products.reduce(function (sum, product) {
        //         var lineTotal = parseFloat(product.cost);
        //         if (!isNaN(lineTotal)) {
        //             return sum + lineTotal;
        //         }
        //     }, 0);

        //     this.invoice_subtotal = subtotal.toFixed(2);

        //     total = (subtotal * (this.invoice_tax / 100)) + subtotal;
        //     total = parseFloat(total);
        //     if (!isNaN(total)) {
        //         this.invoice_total = total.toFixed(2);
        //     } else {
        //         this.invoice_total = '0.00'
        //     }
        // },

        calculateTotal() {
            var subtotal, total;
            subtotal = this.invoice_products.reduce(function (sum, product) {
                var lineTotal = parseFloat(product.line_total);
                if (!isNaN(lineTotal)) {
                    return sum + lineTotal;
                }
            }, 0);

            this.invoice_subtotal = subtotal.toFixed(2);

            total =  this.invoice_tax +this.print_cost+ this.embroidery+ this.misc+ this.cm + this.trims+ this.packaging_trims+this.packaging+ this.transportation+ this.licensee_margin+ this.margin + subtotal;
            total = parseFloat(total);
            if (!isNaN(total)) {
                this.invoice_total = total.toFixed(2);
            } else {
                this.invoice_total = '0.00'
            }
        },
        calculateFinalTotal() {
          this.final_cost=parseFloat(parseFloat(this.total_cost) +parseFloat(this.print_cost) + parseFloat(this.embroidery) + parseFloat(this.misc) + parseFloat(this.cm) + parseFloat(this.trims) + parseFloat(this.packaging_trims) + parseFloat(this.packaging) + parseFloat(this.transportation) + parseFloat(this.licensee_margin) + parseFloat(this.margin)).toFixed(2);
          var f1=this.final_cost;
          var f2=this.final_cost;

          this.percent_cost1=((f1)*(this.licensee_margin))/100;
          this.percent_cost2=((f2)*(this.margin))/100;

          this.total_final_cost=parseFloat(parseFloat(this.total_cost) +parseFloat(this.print_cost) + parseFloat(this.embroidery) + parseFloat(this.misc) + parseFloat(this.cm) + parseFloat(this.trims) + parseFloat(this.packaging_trims) + parseFloat(this.packaging) + parseFloat(this.transportation) + parseFloat(this.licensee_margin) + parseFloat(this.margin) + parseFloat(this.percent_cost1) + parseFloat(this.percent_cost2)).toFixed(2);
        },
        calculateLineTotal(invoice_product) {
            var total = parseFloat(invoice_product.price) * parseFloat(invoice_product.consumption);
            if (!isNaN(total)) {
              this.total_cost=this.total_cost + total;

                this.total_final_cost = this.total_cost 
                invoice_product.cost = total.toFixed(2);
                
            }
            this.calculateTotal();
        },
        deleteRow(index, invoice_product) {
            var idx = this.invoice_products.indexOf(invoice_product);
            if (idx > -1) {
                this.invoice_products.splice(idx, 1);
            }
            this.calculateTotal();
        },
        addNewRow() {
            this.invoice_products.push({
                quality: '',
                weight: '',
                price: '',
                consumption: '',
                cost: 0,
            });
        }
}
  };
</script>
<style>
  .txt_heading{
    text-align: center;
    font-weight: bold;
  }
  .td2{
    width: 250px;
  }
  #final{
    background: #A9A9A9 !important;
  }
  .heading_data{
    text-align: center;
  }
  #subdata{
    margin-top: 15px;
   font-weight: bold;
  }
  #combocell{
    width: 150px
  }
</style>
